<template>
  <div class="sweeper" ref="sweeper">
    <div class="sweeperBg"></div>
    <ul>
      <li>
        <div class="li_count bigTitle">{{ washerCountTotal }}</div>
        <div class="li_title">每日清扫次数</div>
      </li>
      <li>
        <div class="li_count">{{ distanceTotal }}</div>
        <div class="li_unit">km</div>
        <div class="li_title">日均行驶公里数</div>
      </li>
      <li>
        <div class="li_count bigTitle">{{ scheduleCountTotal }}</div>
        <div class="li_title">每日调度次数</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["matrix", "x", "y"],
  data() {
    return {
      pageInfo: 'sweeper.vue',
      computedName: '清扫车调度组件',
      customerId: this.$store.state.customerId,
      distanceTotal: 0,
      scheduleCountTotal: 0,
      washerCountTotal: 0,
      setTime1: null,
    };
  },
  mounted() {
    let that = this;
    let w = $(that.$refs.sweeper).outerWidth();
    let h = $(that.$refs.sweeper).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getListData();
  },
  unmounted() {
    if (this.setTime1) {
      clearTimeout(this.setTime1);
      this.setTime1 = null;
    }
  },
  methods: {
    async getListData() {
      if (this.setTime1) {
        clearTimeout(this.setTime1);
        this.setTime1 = null;
      }
      let summary = CONFIG.requestName + this.$apiOpt.summary;
      let res = await this.$apiUtils.get(summary, {
        customerId: this.customerId,
      });
      if (res) {
        let { distanceTotal, scheduleCountTotal, washerCountTotal } = res;
        this.distanceTotal = distanceTotal;
        this.scheduleCountTotal = scheduleCountTotal;
        this.washerCountTotal = washerCountTotal;
      }
      this.setTime1 = setTimeout(() => {
        this.getListData();
      }, 60 * 1000 * 5);
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.sweeper {
  height: 250px;
  width: 600px;
  .sweeperBg {
    @include bg-box(560px, 178px, "sweeperBg.png");
    margin-top: 32px;
    position: absolute;
  }
  ul {
    height: 100%;
    padding-top: 35px;
    display: flex;
    li {
      z-index: 2;
      flex: 170;
      .li_count {
        height: 140px;
        padding-top: 10px;
        line-height: 130px;
        font-size: 25px;
        text-align: center;
      }
      .li_title {
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #c1eef3;
        line-height: 20px;
        text-align: center;
      }
    }
    li:nth-child(2) {
      flex: 186;
      .li_count {
        height: 140px;
        padding-top: 10px;
        line-height: 120px;
        font-size: 26px;
        text-align: center;
        color: white;
      }
      .li_unit {
        position: absolute;
        top: 60%;
        left: 49%;
        font-size: 12px;
      }
    }
  }
}
</style>
